import type { StreamPlatform } from '@/models/eventCourtStreamLinkModel';

/** Brand names are not translated. `other` uses the link's host instead. */
export const PLATFORM_NAMES: Record<Exclude<StreamPlatform, 'other'>, string> = {
  youtube: 'YouTube',
  facebook: 'Facebook',
  squashtv: 'SquashTV',
  worldsquash: 'WorldSquash.tv',
};

export function platformName(platform: StreamPlatform, url: string): string {
  if (platform !== 'other') return PLATFORM_NAMES[platform];
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}
